// Demo-only (am-tp-demo user groups) — delete after the TP demo. Not a real-feature surface.
import {
  TAffiliateApiErrorPayload,
  TAffiliateUserGroup,
  TAffiliateUserGroupResponse,
  UpdateAffiliateUserGroupProps,
} from '@commenda/types';
import { fetcher } from '@commenda/utils';

export async function updateAffiliateUserGroup(
  affiliateFirmId: string,
  groupId: string,
  props: UpdateAffiliateUserGroupProps
): Promise<{ success: boolean; data?: TAffiliateUserGroup; error?: string }> {
  try {
    const response = await fetcher(
      `demo/affiliate-firms/${affiliateFirmId}/user-groups/${groupId}`,
      {
        method: 'PATCH',
        body: props,
      }
    );

    if (!response.ok) {
      const payload: TAffiliateApiErrorPayload = await response
        .json()
        .catch(() => ({}));
      const message = Array.isArray(payload.message)
        ? payload.message.join(', ')
        : payload.message;
      return {
        success: false,
        error: message ?? 'Could not update the group.',
      };
    }

    const payload: TAffiliateUserGroupResponse = await response.json();
    return { success: true, data: payload.userGroup };
  } catch (error) {
    return { success: false, error: 'Could not update the group.' };
  }
}
